import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_marketing/free-tools")({
	component: RouteComponent,
});

export function RouteComponent() {
	const navigate = useNavigate();
	useEffect(() => {
		navigate({ to: "/tools", replace: true });
	}, [navigate]);
	return null;
}
